var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.405 12.583v2.64m11.91 2.755-1.77 1.866m-10.14 24.934v2.639m-10.377-6.674-1.77 1.866M47.416 30h-2.504m-2.597 12.609-1.771-1.866M15.087 30h-2.504m6.872-10.743-1.77-1.866M37.917 30a7.917 7.917 0 1 1-15.834 0 7.917 7.917 0 0 1 15.834 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.59eda7dc2592f0022d7593b765231fcf.svg";
export { ForwardRef as ReactComponent };